<template>
  <div class="modal fade" id="kt_modal_cancel" tabindex="-1" aria-hidden="true"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          Cancelamento em lote
          <div @click="$emit('onCloseModal')"
               class="btn btn-icon btn-sm btn-active-icon-primary"
               data-bs-dismiss="modal" aria-label="Fechar">
                          <span class="svg-icon svg-icon-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                   fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                      transform="rotate(-45 6 17.3137)"
                                      fill="black"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                      fill="black"/>
                              </svg>
                            </span>
          </div>
        </div>
        <div class="modal-body pt-1">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <button class="nav-link active" id="data-cancel-batch-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-cancel-batch-modal"
                      type="button" role="tab" aria-controls="home" aria-selected="true">
                Cancelar lote
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" id="data-cancel-batch-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-cancel-batch-list-modal"
                      type="button" role="tab" aria-controls="history" aria-selected="false">
                Lotes cancelados
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContentCancelBatch">
            <div class="tab-pane fade show active"
                 id="data-cancel-batch-modal" role="tabpanel"
                 aria-labelledby="home-tab">
              <br>
              <form class="form" @submit.prevent="cancelBatch">
                <div class="row py-5">
                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2 required" for="cancel_schedules_id_prof">Profissional</label>
                    <DropdownUbbi
                      :options="professionals"
                      :filter="true"
                      appendTo="self"
                      v-model="currentProfessionalId"
                      optionLabel="prof_name"
                      optionValue="id_prof"
                      id="cancel_schedules_id_prof"
                      placeholder="Selecione um profissional"
                    />
                    <br>
                  </div>
                  <div class="col-md-7">
                    <div class="flex flex-wrap gap-3 p-fluid">
                      <div class="flex-auto">
                        <label class="fs-6 fw-bold mb-2 required">Intervalos</label>
                        <Calendar v-model="form.date_range" inline selectionMode="range"
                                  :manualInput="false"
                                  dateFormat="yy/mm/dd" :minDate="new Date()"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="flex flex-wrap gap-3 p-fluid">
                      <div class="flex-auto">
                        <label class="fs-6 fw-bold mb-2">Horário inicial</label>
                        <input v-model="form.time_start" v-mask="'##:##'" type="text" class="form-control"
                               placeholder="00:00">
                      </div>
                      <div class="flex-auto">
                        <label class="fs-6 fw-bold mb-2">Horário final</label>
                        <input v-model="form.time_end" v-mask="'##:##'" type="text" class="form-control"
                               placeholder="23:59">
                      </div>
                    </div>
                    <div class="mt-5">
                      Atenção: Será enviado uma mensagem via WhatsApp para todos os pacientes informando sobre o cancelamento
                      e um link para que o mesmo possa realizar o reagendamento da consulta.
                    </div>
                  </div>
                </div>

                <div class="flex-center text-center">
                  <button type="submit" class="btn btn-primary">
                    <span class="indicator-label">Cancelar todos</span>
                  </button>
                </div>
              </form>
            </div>
            <div class="tab-pane fade"
                 id="data-cancel-batch-list-modal" role="tabpanel"
                 aria-labelledby="home-tab">
              <br>

              <div class="table-responsive">
                <table class="table table-bordered table-row-dashed">
                  <thead>
                  <tr class="text-center fw-bolder">
                    <th scope="col">#</th>
                    <th scope="col">Intervalo</th>
                    <th scope="col">Horário inicial/final</th>
                    <th scope="col">Profissional</th>
                    <th scope="col">Cancelado por</th>
                  </tr>
                  </thead>
                  <tbody v-if="batches.length <= 0">
                  <tr>
                    <td colspan="12" class="text-center">
                      Nenhum lote encontrado.
                    </td>
                  </tr>
                  </tbody>
                  <tbody :key="batch.id_sched_cancel_batch" v-for="batch in batches" class="text-center">
                  <tr>
                    <td>
                      <button class="btn btn-sm btn-outline btn-outline-secondary"
                              type="button" data-bs-toggle="collapse" v-if="(batch.schedules?.length ?? 0) > 1"
                              :data-bs-target="'#subTableBatchCancelled-' + batch.id_sched_cancel_batch" aria-expanded="false"
                              aria-controls="collapseExample">
                        <i class="bi bi-plus-circle"></i>
                      </button>
                    </td>
                    <td>
                      {{this.date(batch.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}} -
                      {{this.date(batch.end_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}}
                    </td>
                    <td>
                      {{batch.start_time}} - {{batch.end_time}}
                    </td>
                    <td>{{batch.professional.prof_name}}</td>
                    <td>{{batch.user.first_name}}</td>
                  </tr>
                  <tr>
                    <td colspan="12" class="p-0">
                      <div :id="'subTableBatchCancelled-' + batch.id_sched_cancel_batch" class="collapse">
                        <hr>
                        <h4 class="text-center">Agendamentos</h4>
                        <hr>
                        <table class="table table-bordered border-primary">
                          <thead>
                          <tr>
                            <th>Paciente</th>
                            <th>Especialidade</th>
                            <th>Data/hora agendamento</th>
                            <th>WhatsApp</th>
                            <th>Data hora recebimento</th>
                          </tr>
                          </thead>
                          <tbody :key="batch.id_sched" v-for="schedule in batch.schedules">
                          <tr>
                           <td>{{schedule.patient_name}}</td>
                           <td>{{schedule.specialty || '-'}}</td>
                           <td>{{this.date(schedule.sched_datetime).format('DD/MM/YYYY HH:mm')}}</td>
                           <td>{{maskIt(schedule.whatsapp, '(##) #####-####')}}</td>
                           <td>{{schedule.received_at != null ? this.date(schedule.received_at).format('DD/MM/YYYY HH:mm') : '-'}}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex justify-content-center align-items-center gap-3 mt-3" v-if="batchesMeta && batchesMeta.last_page > 1">
                <button type="button" class="btn btn-sm btn-light"
                        :disabled="loadingBatches || batchesMeta.current_page <= 1"
                        @click="loadBatches(batchesMeta.current_page - 1)">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="text-muted">
                  Página {{ batchesMeta.current_page }} de {{ batchesMeta.last_page }} ({{ batchesMeta.total }} lotes)
                </span>
                <button type="button" class="btn btn-sm btn-light"
                        :disabled="loadingBatches || batchesMeta.current_page >= batchesMeta.last_page"
                        @click="loadBatches(batchesMeta.current_page + 1)">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import {mask} from "vue-the-mask";
import Calendar from 'primevue/calendar';
import DropdownUbbi from "../../components/DropdownUbbi";
import strMask from "@/helpers/strMask";

export default {
  name: "ModalCancelSchedules",
  props: ['idProf', 'openModal'],
  components: {
    DropdownUbbi,
    Calendar,
  },
  directives: {
    mask
  },
  data: () => ({
    form: {
      date_range: [new Date(), new Date()],
      time_start: '00:00',
      time_end: '23:59',
    },
    currentProfessionalId: null,
    batches: [],
    batchesMeta: null,
    batchesPerPage: 10,
    loadingBatches: false,
  }),
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
  },
  mounted() {
    this.currentProfessionalId = this.idProf;
  },
  watch: {
    openModal(newValue) {
      if (newValue) {
        this.resetForm();
        this.loadBatches();
        this.toggleModal();
      }
    },
    idProf(newValue) {
      this.currentProfessionalId = newValue;
    }
  },
  methods: {
    date: moment,
    maskIt(value, mask) {
      return strMask.it(value, mask);
    },
    resetForm() {
      this.form = {
        date_range: [new Date(), new Date()],
        time_start: '00:00',
        time_end: '23:59',
      };
    },
    loadBatches(page = 1) {
      this.loadingBatches = true;
      http.get(`/places/${this.place.id_place}/schedules/cancelled-batches`, {
        params: {page, per_page: this.batchesPerPage},
      }).then((response) => {
        this.batches = response.data.data;
        this.batchesMeta = response.data.meta;
      }).catch((e) => {
        Alert.toastError(e.response.data);
      }).finally(() => {
        this.loadingBatches = false;
      });
    },
    cancelBatch() {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja cancelar os agendamentos?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar!',
        cancelButtonText: 'Fechar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          let form = {
            date_start: this.form.date_range[0],
            date_end: this.form.date_range[1] ?? this.form.date_range[0],
            time_start: this.form.time_start,
            time_end: this.form.time_end,
          };
          http.patch(`/places/${this.place.id_place}/professionals/${this.currentProfessionalId}/schedules/cancel-batch`, form).then(() => {
            this.loadBatches();
            Alert.toastSuccess("Agendamentos cancelados com sucesso.");
            this.$emit('onCancel');

            this.$emit('onCloseModal');
            this.toggleModal();
          }).catch((e) => {
            Alert.toastError(e.response.data);
          });
        }
      });
    },
    toggleModal() {
      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#kt_modal_cancel'));
      modal.toggle();
    }
  }
}
</script>

<style>
.p-calendar .p-inputtext {
  width: 100% !important;
}
</style>